import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import type { FaqPageProps } from 'features/faq-page/types'
import { FAQCategories } from 'features/faq-page/types'
import Faq from 'features/faq-page'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'

const FaqPage = (props: FaqPageProps) => {
  // i18n
  const { t } = useTranslation('faq')

  // Constants
  const seo: SeoProps = {
    title: t('title', 'Veelgestelde vragen')
  }

  return (
    <Layout {...{ seo }}>
      <Faq {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const [sections, questions] = await Promise.all([
    cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.COMMON], locale),
    cmsLib.getFaqArticles(faqCategoriesSlugs[FAQCategories.COMMON], locale)
  ])

  return {
    props: {
      questions,
      sections,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'faq'], i18nConfig))
    }
  }
}

export default FaqPage
